export enum DiscountType {
  ABSOLUTE_AMOUNT = 'ABSOLUTE_AMOUNT',
  PERCENTAGE = 'PERCENTAGE',
}
